import Swal from 'sweetalert2';
import AdminNavBar from '@/components/AdminNavBar/AdminNavBar.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { validate_first_name, validate_last_name, validate_email, validate_phone_number, validate_invalid_characters} from '@/utils/validations.js';
import { format_date } from '@/utils/date_formatter';
import CustomTabs from '@/components/CustomTab/CustomTab.vue';

export default {
  name: 'ViewClient',
  components: {
    AdminNavBar,
    CustomTabs
  },
  data: () => ({
    admin_data: [],
    get_user_id: '',
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    date_joined: '',
    currentTab: localStorage.getItem('view_client_tab') || 'client_profile', // Default active tab

    searchTerm: '',
    entriesPerPage: 10,
    currentPage: 1,
    permissionUsers: [],
    isLoadingPermissions: false,
    
    tabs: [
      { label: 'Client Profile', value: 'client_profile' },
      { label: 'Permissions', value: 'assign_permission' },
    ]
  }),
  watch: {

    currentTab(newTab) {

      localStorage.setItem('view_client_tab', newTab);

      if (newTab === 'assign_permission') {
        this.currentPage = 1;
        this.searchTerm = '';

        this.loadClientsWithPermissions();
      }
    },

    searchTerm() {
      this.currentPage = 1;
    },

    entriesPerPage() {
      this.currentPage = 1;
    }
  },
  methods: {
    formatDate(date) {
      return format_date(date);
    },
    
  updateUserRole(userId, role, isChecked) {
    const user = this.permissionUsers.find(u => u.id === userId);
    if (!user) return;

    const previous_value = user[role];

    user[role] = isChecked;

    const TOKEN = localStorage.getItem('token');
    const BASE_URL = API_BASE_URL;
    if (!BASE_URL) {
    
      user[role] = previous_value;
      return;
    }

    const SAVE_PERMISSION_URL = `${BASE_URL}/verify_api/system_management_api/client_workflow_permission_api/`;

    const requestData = {
      client_id: userId,
      can_create_workflow: isChecked
    };

    $.ajax({
      method: "POST",
      url: SAVE_PERMISSION_URL,
      data: JSON.stringify(requestData),
      contentType: 'application/json',
      headers: {
        Authorization: `Token ${TOKEN}`
      },
      success: (response) => {
        if (response.status === 'success') {
          // Optionally show toast or success message here
        } else {
          // Revert optimistic update on error
          user[role] = previous_value;
          Swal.fire({
            icon: 'error',
            text: response.message || 'Failed to update permission.',
            confirmButtonText: 'OK'
          });
        }
      },
      error: (error) => {
      
        user[role] = previous_value;

        let errorMessage = 'Failed to update permission. Please try again.';
        if (error.responseJSON && error.responseJSON.message) {
          errorMessage = error.responseJSON.message;
        }
        Swal.fire({
          icon: 'error',
          text: errorMessage,
          confirmButtonText: 'OK'
        });
      }
    });
  },

    get_client_details(user_id) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      if (!BASE_URL) {
        this.showError('.error-message', 'Server configuration error. Please try again later.');
        return;
      }
      const GET_USER_URL = `${BASE_URL}/verify_api/verify_admin_api/view_user_api/${user_id}`;

      $.ajax({
        method: "GET",
        url: GET_USER_URL,
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          Swal.fire({
            text: 'Loading users...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
            this.get_user_id = response.user[0].id
            this.first_name = response.user[0].first_name;
            this.last_name = response.user[0].last_name;
            this.email = response.user[0].email;
            this.phone_number = '0' + response.user[0].phone_number;
            this.date_joined =  response.user[0].date_joined.split('T')[0];
        
            Swal.close();
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            text: 'Failed to load users. Please try again.',
            confirmButtonText: 'OK'
          });
        }
      });
    },
    validate_inputs() {
      if (!validate_first_name(this.first_name)) return false;
      if (!validate_last_name(this.last_name)) return false;
      if (!validate_email(this.email)) return false;
      if (!validate_phone_number(this.phone_number)) return false;
      
      return true;
    },
    validate_name(field_name) {
      this[field_name] = validate_invalid_characters(this[field_name]);
    },

    validate_phone_number() {
      this.phone_number = this.phone_number.replace(/\D/g, '');
    },

    edit_user(get_user_id) {
      if (!this.validate_inputs()) {
        return;
      }
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      if (!BASE_URL) {
        this.showError('.error-message', 'Server configuration error. Please try again later.');
        return;
      }
      const EDIT_USER_URL = `${BASE_URL}/verify_api/verify_admin_api/edit_user_api/${get_user_id}`;
      const FORM_DATA = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone_number: this.phone_number
      };
  
      $.ajax({
        method: "POST",
        url: EDIT_USER_URL,
        data: JSON.stringify(FORM_DATA),
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          Swal.fire({
            text: 'Updating user...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
          Swal.fire({
            icon: 'success',
            text: response.message,
            confirmButtonText: 'OK'
          });
        },
        error: (error) => {
          Swal.fire({
            icon: 'error',
            text: error.responseJSON.error,
            confirmButtonText: 'OK'
          });
        }
      });
    },

    switchToTab(tabValue) {
      this.currentTab = tabValue;
    },

    resetToDefaultTab() {
      this.currentTab = 'client_profile';
    },

    loadClientsWithPermissions() {
        const TOKEN = localStorage.getItem('token');
        const BASE_URL = API_BASE_URL;
        
        if (!BASE_URL) {
            return;
        }

        const GET_CLIENTS_WITH_PERMISSIONS_URL = `${BASE_URL}/verify_api/system_management_api/get_clients_with_permissions_api/`;
        this.isLoadingPermissions = true;

        $.ajax({
            method: "GET",
            url: GET_CLIENTS_WITH_PERMISSIONS_URL,
            headers: {
                Authorization: `Token ${TOKEN}`
            },
            success: (response) => {
                if (response.status === 'success') {

                    this.permissionUsers = response.data.map(client => {
                        const fullName = client.client_name || '';
                        const nameParts = fullName.trim().split(' ');
                        const firstName = nameParts[0] || '';
                        const lastName = nameParts.slice(1).join(' ') || '';
                        
                        return {
                            id: client.client_id,
                            first_name: firstName,
                            last_name: lastName,
                            email: client.client_email,
                            date_joined: client.date_joined || '', 
                            workflow_access: client.can_create_workflow
                        };
                    })
                    .sort((a, b) => new Date(b.date_joined) - new Date(a.date_joined));

                } else {
                    Swal.fire({
                        icon: 'error',
                        text: response.message,
                        confirmButtonText: 'OK'
                    });
                }
                this.isLoadingPermissions = false;
            },
            error: (error) => {
                this.isLoadingPermissions = false;
                
                let errorMessage = 'Failed to load clients with permissions. Please try again.';
                if (error.responseJSON && error.responseJSON.message) {
                    errorMessage = error.responseJSON.message;
                }
                
                Swal.fire({
                    icon: 'error',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });
            }
        });
    },

    saveUserPermissions(userId, role, isChecked, previous_value, userObject) {
        const TOKEN = localStorage.getItem('token');
        const BASE_URL = API_BASE_URL;
        
        if (!BASE_URL) {

            userObject[role] = previous_value;
            return;
        }
  
        const SAVE_PERMISSION_URL = `${BASE_URL}/verify_api/system_management_api/client_workflow_permission_api/`;
        
        const requestData = {
            client_id: userId,
            can_create_workflow: isChecked
        };
        
        $.ajax({
            method: "POST",
            url: SAVE_PERMISSION_URL,
            data: JSON.stringify(requestData),
            contentType: 'application/json',
            headers: {
                Authorization: `Token ${TOKEN}`
            },
            success: (response) => {
                if (response.status === 'success') {

                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true
                    });
                    
                    Toast.fire({
                        icon: 'success',
                        title: 'Permission updated successfully'
                    });
                } else {
                    userObject[role] = previous_value;
                    
                    Swal.fire({
                        icon: 'error',
                        text: response.message || 'Failed to update permission.',
                        confirmButtonText: 'OK'
                    });
                }
            },
            error: (error) => {
                userObject[role] = previous_value;
                
                let errorMessage = 'Failed to update permission. Please try again.';
                if (error.responseJSON && error.responseJSON.message) {
                    errorMessage = error.responseJSON.message;
                }
                
                Swal.fire({
                    icon: 'error',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });
            }
        });
    },
  },
  
  computed: {
    currentUserRole() {
      return this.$store.getters.get_user_role;
    },

    isSystemAdmin() {
      return this.currentUserRole === 'SystemAdmin';
    },

    currentTabData() {
      return this.tabs.find(tab => tab.value === this.currentTab);
    },

    filteredUsers() {
      if (!this.searchTerm) {
        return this.permissionUsers;
      }
      return this.permissionUsers.filter(user => 
        user.first_name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.last_name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        user.email.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },

    paginatedUsers() {
      const start = (this.currentPage - 1) * this.entriesPerPage;
      const end = start + this.entriesPerPage;
      return this.filteredUsers.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredUsers.length / this.entriesPerPage);
    }
  },
  
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    
    const user_id = this.$route.params.user_id;
    this.get_client_details(user_id);

    if (this.currentTab === 'assign_permission') {
      this.loadClientsWithPermissions();
    }
  }
};